<template>
  <div class="wrapper">
    <h1 v-if="adminWhichComponent != 'trainingDashboard' && adminWhichComponent != 'trainingRegDetails'">Cereal City Science Administrative Dashboard</h1>
    <h1 v-if="adminWhichComponent == 'trainingDashboard'">Cereal City Science Training Dashboard</h1>
    <h1 v-if="adminWhichComponent == 'trainingRegDetails'">Cereal City Science Registration Details</h1>
    <!-- {{ email list }} -->
    <button type="button" @click.prevent="toggleCreateDistrict" v-if="showCreateButton">Create New District</button>
    <button type="button" @click.prevent="toggleManageUsers" v-if="showUsersButton">View/Manage Users</button>
    <button type="button" @click.prevent="returnToDashboard" v-if="showUsersButton">Return to Dashboard</button>
    <!-- <button type="button" @click.prevent="test">Test</button> -->
    <!-- <button type="button" @click.prevent="toggleAddUnit">Add Units</button> -->
    <p v-if="generalMsg" class="msg">{{ generalMsg }}</p>
    <create-district v-if="adminWhichComponent == 'createDistrict'" />
    <manage-district v-if="adminWhichComponent == 'manageDistrict'" />
    <manage-users v-if="adminWhichComponent == 'manageUsers'" />
    <manage-user v-if="adminWhichComponent == 'manageUser'" />
    <training-dashboard v-if="adminWhichComponent == 'trainingDashboard'" />
    <training-reg-details v-if="adminWhichComponent == 'trainingRegDetails'" />
    <add-unit v-if="showAddUnit" />
    <district-list v-if="adminWhichComponent == 'districtList'"/>
    <create-user v-if="adminWhichComponent == 'createUser'"/>
    <user-breakdown v-if="showUserBreakdown" />
  </div>
</template>

<script>
import CreateDistrict from '@/components/admin/CreateDistrict.vue'
import ManageDistrict from '@/components/admin/ManageDistrict.vue'
import ManageUsers from '@/components/admin/ManageUsers'
import ManageUser from '@/components/admin/ManageUser'
import DistrictList from '@/components/admin/DistrictList.vue'
import AddUnit from '@/components/admin/AddUnit.vue'
import CreateUser from '@/components/admin/CreateUser.vue'
import UserBreakdown from '@/components/admin/UserBreakdown.vue'
import TrainingDashboard from '@/components/admin/TrainingDashboard.vue'
import TrainingRegDetails from '@/components/admin/TrainingRegDetails.vue'

// const fb = require('./../../firebase/firebase')
import { mapState } from 'vuex'

export default {
  data() {
    return {
      showAddUnit: false,
      showUserBreakdown: false,
      emails: []
    }
  },
  computed: {
    ...mapState([ 'adminWhichComponent', 'generalMsg' ]),
    showCreateButton() {
      return this.adminWhichComponent === 'manageDistrict' || this.adminWhichComponent === 'districtList'
    },
    showUsersButton() {
      return this.adminWhichComponent === 'manageDistrict'
    }
  },
  components: {
    CreateDistrict,
    ManageDistrict,
    ManageUsers,
    ManageUser,
    DistrictList,
    AddUnit,
    CreateUser,
    UserBreakdown,
    TrainingDashboard,
    TrainingRegDetails
  },
  methods: {
    toggleCreateDistrict() {
      this.$store.commit('SET_GENERAL_MSG', null)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'createDistrict')
    },
    toggleManageUsers() {
      this.$store.commit('SET_GENERAL_MSG', null)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageUsers')
    },
    toggleTrainingDashboard() {
      this.$store.commit('SET_GENERAL_MSG', null)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'trainingDashboard')
    },
    returnToDashboard() {
      this.$store.commit('SET_DISTRICT_ID', null)
      this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
    },
  },
  mounted() {
    // fb.usersCollection.get().then((snap) => {
    //   snap.forEach((doc) => {
    //     this.emails.push({
    //       email: doc.data().userEmail,
    //       firstName: doc.data().userFirstName,
    //       lastName: doc.data().userLastName
    //     })
    //   })
    // })
  }
}
</script>

<style lang="css" scoped>
button {
  margin: 10px;
}
.msg {
  color: darkOrange;
}
.wrapper {
  margin: 10px 160px;
}
h1 {
  margin-bottom: 20px;
}
</style>
